import { AnimationEvent, usePopup } from '@libs/hooks';
import { TPopupProps } from '@libs/types';
import { Portal } from '@libs/utils';
import clsx from 'clsx';
import { TouchEvent, useCallback, useEffect, useEffectEvent, useState } from 'react';
import { flushSync } from 'react-dom';

import styles from './bottomSheet.module.css';

const Popup = ({ content, modal, setPopup }: TPopupProps) => {
    const [animated, setAnimated] = useState(false);
    const [data, setData] = useState<typeof content>(null);
    const { handlers, overlayRef, overlayClick } = usePopup(data, setAnimated, modal);

    const updatePopup = useEffectEvent((content: TPopupProps['content'], data: TPopupProps['content']) => {
        if (content) {
            setData(content);
        } else if (data) {
            setAnimated(true);
        }
    });

    useEffect(() => {
        updatePopup(content, data);
    }, [content, data]);

    const closeAnimationPopup = useCallback(
        (_e: AnimationEvent<HTMLDivElement>) => {
            flushSync(() => {
                setData(null);
                setAnimated(false);
                setPopup(null);
            });
        },
        [setPopup],
    );

    const touchEnd = (e: TouchEvent) => {
        const target = e?.target as HTMLDivElement;
        const dashWrapper = target?.getAttribute?.('dash');
        if (dashWrapper) {
            e.preventDefault();
            setAnimated(true);
        }
    };

    if (data) {
        return (
            <Portal>
                <div id="popup" {...handlers}>
                    <div className={styles.overlay} onClick={overlayClick}>
                        <div className={styles.popupOuter}>
                            <div
                                className={clsx(styles.popupBox, animated && styles.closeAnimationName)}
                                onAnimationEnd={closeAnimationPopup}
                                ref={overlayRef}
                                onTouchEnd={touchEnd}
                            >
                                {data}
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>
        );
    }
    return null;
};
export default Popup;
